<template lang="pug">
.navbar-item.navbar-show-on-top
	span {{ $t("menu.promo_code") }}
	.buttons
		//-a.button.is-primary.is-jtwia.button-height-navbar(@click="goPromoCode")
			div
				.navbar-partner-logo
					img(src="/img/jtwia_small.png")

		//-a.button.is-primary.is-vodafone.button-height-navbar(@click="goPromoCode")
			div
				.navbar-partner-logo
					img(src="/img/vodafone_business_small.png")
		a.button.is-primary.is-fastweb.button-height-navbar(@click="goPromoCode")
			div
				.navbar-partner-logo
					img(src="/img/fastweb_small.png")
		a.button.is-primary.is-agos.button-height-navbar(@click="goPromoCode")
			div
				.navbar-partner-logo
					img(src="/img/agos_small.png")
</template>

<script>
export default {
	methods: {
		goPromoCode() {
			this.$router.push('/' + this.$route.params.language + '/promo-code')
		}
	}
}
</script>
